<template>
    <div>
        <hd-header></hd-header>
        <div style="padding-top: 130px;">
            <div style="text-align: center;">
                <img src="../../assets/images/progress/four.png" alt="">
            </div>
            <div
                style="display: flex;justify-content: center;align-items: center;margin-bottom: 60px;margin-top: 50px;">
                <el-card style="width: 1000px;">
                    <div slot="header" class="clearfix">
                        <span>加入学校</span>
                    </div>
                    <el-form :model="form" :label-position="position" label-width="100px">
                        <el-form-item label="申请学校:">
                            <div style="width: 350px;">
                                <SubSchool @getSchoolId="getSchoolId"></SubSchool>
                            </div>
                            <p class="formStatic">比如“清华大学”</p>
                        </el-form-item>
                        <el-form-item label="入住角色:">
                            <el-radio v-model="form.type" label="1">教师</el-radio>
                            <el-radio v-model="form.type" label="0">学生</el-radio>
                        </el-form-item>
                        <el-form-item label="申请理由:">
                            <el-input v-model="form.reason" style="width: 350px;" type="textarea" :rows="5"
                                      placeholder="请输入申请理由"></el-input>
                            <p class="formStatic">
                                <el-checkbox label="我同意管理员查看我的实名信息" size="small" v-model="isAgree"
                                             style="margin-top: 10px;">
                                </el-checkbox>
                            </p>
                        </el-form-item>
                        <el-form-item>
                            <!--                            <el-button type="primary" plain="plain" size="mini" @click="resetForm">取消</el-button>-->
                            <el-button type="primary" size="mini" :disabled="!canSave" @click="doSave">保存</el-button>
                        </el-form-item>
                        <el-form-item label="申请列表:">
                            <!-- <el-tag v-for="tag in tags" :type="tag.type" closable effect="dark"
                                style="margin-right: 10px;">
                                {{tag.name}}
                            </el-tag> -->
                            <div class="divJoined" v-for="each in items">
                                <el-row>
                                    <el-col :span="12">
                                        <p style="text-align: center;margin: 0;padding: 0;line-height: 0;">
                                            <img :src="each.school_logo" alt=""
                                                 style="border-radius: 50%;height: 80px;">
                                        </p>
                                        <p style="text-align: center;margin: 0;padding: 0;line-height: 25px;">
                                            {{ each.school_name }}</p>
                                    </el-col>
                                    <el-col :span="12">
                                        <p style="color:#999999;text-align: right;margin-right: 2em;">申请角色：<span
                                            style="color: #000000;">{{ each.role_show }}</span><i
                                            class="el-icon-circle-close iRemove" @click="removeOne(each.id)"></i></p>
                                        <p style="color:#999999;text-align: right;margin-right: 2em;">
                                            申请日期：{{ each.reg_time_show }}
                                        </p>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" style="width: 180px;" @click="doPre()" plain="plain">上一步
                            </el-button>
                            <el-button type="primary" style="width: 180px;" @click="doNext()" :disabled="!canCommit">提交
                            </el-button>
                        </el-form-item>
                    </el-form>
                </el-card>
            </div>
        </div>
        <hd-footer v-if="footerIsShow"></hd-footer>
    </div>
</template>

<script>
import HdHeader from '../public/Header.vue'
import HdFooter from '../public/FooterLogined.vue'
import SubSchool from '../public/sub/SubSchool'

export default {
    name: 'JoinSchool',
    components: {
        HdHeader,
        HdFooter,
        SubSchool
    },
    created () {
        this.getList()
    },
    mounted () {
    },
    destroyed () {
    },
    data: function () {
        return {
            position: 'right',
            isAgree: false,
            form: {
                id: 0,
                type: '1',
                reason: ''
            },
            canSave: false,
            canCommit: false,
            items: [],
            footerIsShow: true
        }
    },
    methods: {
        doPre: function () {
            this.$router.push({
                path: '/teacher-cert'
            })
        },
        doNext: function () {
            this.$router.push({
                path: '/teacher-success'
            })
        },
        judgeCanSave () {
            this.canSave = this.form.id > 0 && this.form.reason.length > 0 && this.isAgree
        },
        resetForm () {
            this.form.type = '1'
            this.form.reason = ''
            this.isAgree = false
            this.canSave = false
        },
        doSave () {
            this.$ajax.post('/api/schooluserapply/create', {
                school_id: this.form.id,
                role: this.form.type,
                reason: this.form.reason
            }).then((r) => {
                //新增成功，重新获取
                this.$message.success('申请成功')
                this.getList()
            })
        },
        //获取选中的学校id
        getSchoolId: function (id) {
            this.form.id = id
        },
        getList () {
            this.$ajax.get('/api/schooluserapply/getlist').then((r) => {
                this.items = r.data.items
                this.resetPosition()
            })
        },
        deleteJoined () {
            //先删除所有的加入记录
            this.$ajax.get('/api/schooluserapply/deleteJoined').then((r) => {

            })
        },
        resetPosition () {
            console.log('resetPosition')
            this.footerIsShow = false
            setTimeout(_ => {
                this.footerIsShow = true
            }, 500)
        },
        removeOne (id) {
            this.$confirm('此操作将删除申请加入的学校，是否继续？', '提示', {
                confirmButtonText: '确认删除',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$ajax.get('/api/schooluserapply/delete?id=' + id).then((res) => {
                    this.$message.success('删除成功')
                    //重新获取列表
                    this.getList()
                })
            })
        }
    },
    watch: {
        'form.id': {
            handler (newValue, oldValue) {
                this.judgeCanSave()
            },
            immediate: true,
            deep: true
        },
        'form.reason': {
            handler (newValue, oldValue) {
                this.judgeCanSave()
            },
            immediate: true,
            deep: true
        },
        'form.isAgree': {
            handler (newValue, oldValue) {
                this.judgeCanSave()
            },
            immediate: true,
            deep: true
        },
        isAgree (newValue, oldValue) {
            this.judgeCanSave()
        },
        'items.length': {
            handler (newValue, oldValue) {
                console.log('items.length', newValue, oldValue)
                this.canCommit = newValue > 0
            },
            immediate: true,
            deep: true
        }
    }
}
</script>

<style>
.colDesc {
    font-size: 12px;
    color: #999999;
}

.colDesc p {
    padding: 0;
    margin: 0;
    line-height: 25px;
}

.formStatic {
    font-size: 12px;
    padding: 0;
    margin: 0;
    line-height: 25px;
    color: #999999;
}

.divJoined {
    background-color: #fdfdfd;
    border: 1px solid #eaeaee;
    width: 400px;
    border-radius: 5px;
    padding-top: 1em;
    padding-bottom: 1em;
    margin-top: 1em;
}

.iRemove {
    cursor: pointer;
    font-size: 1.5em;
    position: relative;
    top: -22px;
    right: -20px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/JoinSchool.vue